import React from "react";
import { Modal } from "react-bootstrap";

const CustomModalComp = ({
  show,
  onHide,
  title,
  children,
  backdrop = false,
  size = "xl",
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      // backdrop={backdrop && "static"}
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "80vh", overflow: "auto" }}>
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default CustomModalComp;
